import { scrollTo, generateUuid } from '@/helpers'

const initialState = () => ({
    banners: []
})

export default {
    namespaced: true,
    state: initialState(),
    mutations: {
        SHOW_BANNER(state, { status, title, message, buttonLabel, buttonAction }) {
            // buttonLabel: String,
            // buttonAction: Function,
            // title: String,
            // message: String,
            // status: String // warning, success, info
            state.banners.pop() // TODO: temp show only one banner

            state.banners.push({
                key: generateUuid(),
                status,
                title,
                message,
                buttonLabel,
                buttonAction
            })

            scrollTo('top')
        },
        CLOSE_BANNER(state) {
            state.banners.pop()
        }
    },
    getters: {
        banners: state => state.banners
    }
}



// WEBPACK FOOTER //
// ./src/stores/banners.js